import React, { useEffect } from 'react'
import Button from '../ui/Button'

/**
 * 대본 입력 컴포넌트
 */
function ScriptInput({ 
  projectName, 
  setProjectName, 
  scriptTitle, 
  setScriptTitle, 
  script, 
  setScript, 
  parseScript, 
  setTitleSettings, 
  onTitleSettingsChange, 
  titleSettings 
}) {
  
  // 컴포넌트 마운트 시 또는 scriptTitle 변경 시 titleSettings 초기화
  useEffect(() => {
    if (scriptTitle && setTitleSettings) {
      const updatedSettings = {
        ...titleSettings,
        text: scriptTitle,
        enabled: titleSettings?.enabled !== false  // 기존 설정 유지
      }
      setTitleSettings(updatedSettings)
      
      // Canvas 미리보기 즉시 업데이트
      if (onTitleSettingsChange) {
        onTitleSettingsChange(updatedSettings)
      }
    }
  }, [scriptTitle]) // scriptTitle이 변경될 때마다 실행
  
  return (
    <div className="sidebar-section">
      {/* <div style={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '20px'
      }}>
        <img 
          src="/logo.png" 
          alt="테라아이 로고"
          style={{
            height: '28px',
            width: 'auto',
            objectFit: 'contain'
          }}
        />
      </div> */}
      <h2 style={{ 
        textAlign: 'center', 
        marginBottom: '15px', 
        color: 'white', 
        fontSize: '18px', 
        fontWeight: '400' 
        
        }}>대본 입력기</h2>
      
      {/* 영상 제목 입력 필드 */}
      <div style={{ marginBottom: '15px' }}>
        <label style={{ fontSize: '12px', color: '#999', marginBottom: '5px', display: 'block' }}>영상 제목</label>
        <textarea
          value={scriptTitle}
          onChange={(e) => {
            const newTitle = e.target.value
            setScriptTitle(newTitle)
            
            // 제목이 변경될 때마다 즉시 titleSettings 업데이트
            if (setTitleSettings) {
              const updatedSettings = {
                ...titleSettings,
                text: newTitle,
                enabled: true  // 제목 입력 시 자동으로 활성화
              }
              setTitleSettings(updatedSettings)
              
              // 실시간 Canvas 미리보기 업데이트
              if (onTitleSettingsChange) {
                onTitleSettingsChange(updatedSettings)
              }
            }
          }}
          placeholder="영상에 표시될 제목을 입력하세요"
          className="title-input"
          rows={2}
          style={{
            width: '100%',
            height: '50px',
            padding: '10px 12px',
            background: 'rgba(255, 255, 255, .05)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '8px',
            color: '#ffffff',
            fontSize: '14px',
            outline: 'none',
            transition: 'all 0.2s ease',
            resize: 'none',
            fontFamily: 'inherit',
            lineHeight: '1.4',
            boxSizing: 'border-box'
          }}
          onFocus={(e) => {
            e.target.style.border = '1px solid rgba(255, 255, 255, 0.5)'
            e.target.style.background = 'rgba(0, 0, 0, 0.7)'
            e.target.style.boxShadow = '0 0 0 2px rgba(255, 255, 255, 0.1)'
          }}
          onBlur={(e) => {
            e.target.style.border = '1px solid rgba(255, 255, 255, 0.2)'
            e.target.style.background = 'rgba(255, 255, 255, .05)'
            e.target.style.boxShadow = 'none'
          }}
        />
      </div>
      
      {/* 대본 입력 필드 */}
      <textarea
        value={script}
        onChange={(e) => setScript(e.target.value)}
        placeholder="대본을 입력하세요. 대본 한 줄이 하나의 페이지와 자막으로 구성되어 분할됩니다."
        className="sidebar-textarea"
        rows={3}
      />
      
      <Button 
        onClick={parseScript}
        variant="primary"
        disabled={!script.trim()}
        style={{ marginTop: '15px' }}
      >
        페이지 만들기
      </Button>
    </div>
  )
}

export default ScriptInput